import axios from 'axios'
import { Toast } from 'vant';
import qs from 'qs'
import { v4 as uuidv4 } from 'uuid'
import router from '../router/index'

let noQsAry = ['/api/user/identity/apply', '/api/file/upload']

let notToken = ['/api/mobile/sendvercode', '/api/login/mobile/code']
let typeJsonUrl = ['/api/user/identity/apply']
let upload = ['/api/file/upload']

function setHeaer(url) {
  //通过url判断header

  let headers = {
    "x-client-type": "2",
    "Content-Type": "application/x-www-form-urlencoded",
  }
  let bashaUid = localStorage.getItem('bashaUid')
  if (!bashaUid) {
    bashaUid = uuidv4()
    localStorage.setItem('bashaUid', bashaUid)
  }
  headers["x-client-device-id"] = bashaUid
  //不需要token的header 
  if (!notToken.includes(url)) {
    headers["x-auth-token"] = localStorage.getItem('bashaToken')
  }
  if (!bashaUid) {
    headers["x-auth-token"] = localStorage.getItem('bashaToken')
  }
  //headerType 是Json
  if (typeJsonUrl.includes(url)) {
    headers["Content-Type"] = "application/json"
  }
  if (upload.includes(url)) {
    headers["Content-Type"] = "multipart/form-data"
  }
  return headers
}

//其他content-Type 
console.log(process.env.APP_URL)
// APP_URL
let APP_URL = process.env.APP_URL
export default {
  post: (url, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'post',
        data: noQsAry.includes(url) ? params : qs.stringify(params),
        url: APP_URL + url,
        headers: setHeaer(url)
      }).then(res => {
        if (res.data.code == 0) {
          resolve(res);
        } else {
          if (res.data.code == 12011 || res.data.code == 12028 || res.data.code == 12017) {
            reject(res)
            return;
          }
          Toast(res.data.msg);
          reject(res)
          if (res.data.code == 11401) {
            router.push({ name: 'login' })
          } else if (res.data.code == 12022) {
            router.push({ name: 'authentication' })
          }
        }
      }).catch(err => {
        console.log("post:" + err.response.data)
        reject(err)
      })

    });
  },
  put: (url, params) => {
    return new Promise((resolve, reject) => {
      axios({
        method: 'put',
        data: noQsAry.includes(url) ? params : qs.stringify(params),
        url: APP_URL + url,
        headers: setHeaer(url)
      }).then(res => {
        if (res.data.code == 0) {
          resolve(res);
        } else {
          if (res.data.code == 12011 || res.data.code == 12028 || res.data.code == 12017) {
            return;
          }
          Toast(res.data.msg);
          reject(res)
          if (res.data.code == 11401) {
            router.push({ name: 'login' })
          } else if (res.data.code == 12022) {
            router.push({ name: 'authentication' })
          }
        }
      }).catch(err => {
        console.log("post:" + err.response.data)
        reject(err)
      })

    });
  },
  get: (url, params) => {
    return new Promise((resolve, reject) => {
      axios({ method: 'get', params: params, url: APP_URL + url, headers: setHeaer(url) }).then(res => {
        let code = res.data.code
        if (code == 0 || code == 12023 || code == 12024) {
          resolve(res);
        } else {
          Toast(res.data.msg);
          reject(res)
        }
      }).catch(err => {
        let retCode = err.response.data.code;
        let retMsg = err.response.data.msg;
        if (retCode == 12027 || retCode == 11401 || retCode == 11403) {
          router.push({ name: 'login' })
        } else if (retCode == 12013 || retCode == 12015 || retCode == 12014) {
          Toast(retMsg);
        } else {
          reject(err)
        }

      })
    });
  },
};


// WEBPACK FOOTER //
// ./src/js/request.js